import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 264 107",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "136.5",
      y: "33.5",
      width: "95",
      height: "39",
      rx: "7.5",
      stroke: "var(--dt-action-color-border-base-outlined-default)",
      id: "button-sencondary-bg"
    }, null, -1),
    _createElementVNode("rect", {
      x: "32",
      y: "33",
      width: "96",
      height: "40",
      rx: "8",
      fill: "var(--dt-action-color-background-base-primary-default)",
      id: "button-primary-bg"
    }, null, -1),
    _createElementVNode("rect", {
      x: "60",
      y: "49",
      width: "40",
      height: "8",
      rx: "4",
      fill: "var(--dt-action-color-foreground-base-primary-default)",
      id: "Rectangle 494"
    }, null, -1),
    _createElementVNode("rect", {
      x: "164",
      y: "49",
      width: "40",
      height: "8",
      rx: "4",
      fill: "var(--dt-action-color-foreground-base-default)",
      id: "Rectangle 495"
    }, null, -1)
  ]))]))
}
export default { render: render }